export default __webpack_public_path__ + "static/media/disclaimer.c9925f2f.jpg";